import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";

type DocPage = {
  title: string;
  href: string;
};

type DocsNavigationProps = {
  previous?: DocPage;
  next?: DocPage;
};

export const DocsNavigation = ({ previous, next }: DocsNavigationProps) => {
  if (!previous && !next) return null;

  return (
    <div className="grid grid-cols-2 gap-4 mt-12 pt-8 border-t border-border/50">
      {/* Previous Page */}
      {previous ? (
        <Link
          to={previous.href}
          className="flex flex-col gap-2 p-4 border border-border rounded-lg hover:bg-accent transition-colors group"
        >
          <span className="text-xs text-muted-foreground">Previous</span>
          <span className="flex items-center gap-2 font-semibold group-hover:text-primary transition-colors">
            <ChevronLeft className="h-4 w-4" />
            {previous.title}
          </span>
        </Link>
      ) : (
        <div />
      )}

      {/* Next Page */}
      {next ? (
        <Link
          to={next.href}
          className="flex flex-col gap-2 p-4 border border-border rounded-lg hover:bg-accent transition-colors group text-right"
        >
          <span className="text-xs text-muted-foreground">Next</span>
          <span className="flex items-center justify-end gap-2 font-semibold group-hover:text-primary transition-colors">
            {next.title}
            <ChevronRight className="h-4 w-4" />
          </span>
        </Link>
      ) : (
        <div />
      )}
    </div>
  );
};

